/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Selectversion1Inputs */

const zh_course_selectversion1 = /** @type {(inputs: Course_Selectversion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择学习资源`)
};

const en_course_selectversion1 = /** @type {(inputs: Course_Selectversion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Study Resource`)
};

const es_course_selectversion1 = /** @type {(inputs: Course_Selectversion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar recurso`)
};

/**
* | output |
* | --- |
* | "Select Study Resource" |
*
* @param {Course_Selectversion1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_selectversion1 = /** @type {((inputs?: Course_Selectversion1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Selectversion1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_selectversion1(inputs)
	if (locale === "en") return en_course_selectversion1(inputs)
	return es_course_selectversion1(inputs)
});
export { course_selectversion1 as "course_selectVersion" }